import { Authenticated, useOne } from "@refinedev/core";
import { useEffect } from "react";
import { StoryboardStudio } from "../components/storyboard/StoryboardStudio";
import { useBoundStore } from "@/store";
import { MediaProjectResponse } from "../types";
import { useProjectNavigate } from "./hooks/useProjectNavigate";

export const ProjectStoryboardEditor = ({
  redirectLegacy,
}: {
  redirectLegacy?: boolean;
}) => {
  const setSidebarCollapsed = useBoundStore(
    (state) => state.setSidebarCollapsed
  );

  const {
    params: { id, instanceId, storyboardId },
  } = useProjectNavigate();

  const { data } = useOne<MediaProjectResponse>({
    resource: `media/projects`,
    id,
  });
  const project = data?.data;
  const { navigateToStoryboard } = useProjectNavigate();

  if (redirectLegacy && project?.media?.length > 0) {
    // support routes like
    // https://app.dev.docustream.ai/media/projects/3660e437-9a2f-493b-a27a-6f1401ccaf08/storyboard/dba59354-fff0-49a3-bff1-a587adce7c50
    const storyboardSettingsId = project.storyboards.find(
      (storyboard) => storyboard.asset_id === storyboardId
    )?.id;
    navigateToStoryboard({
      projectId: id,
      storyboardId: storyboardSettingsId,
      instanceId: project?.media?.find(
        (media) => media.storyboard_settings_id === storyboardSettingsId
      )?.instance_id,
    });
  }

  useEffect(() => {
    setSidebarCollapsed(true);

    return () => {
      setSidebarCollapsed(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Authenticated key="project_storyboard">
      {project && (
        <StoryboardStudio
          project={project}
          storyboardId={storyboardId}
          instanceId={instanceId}
        />
      )}
    </Authenticated>
  );
};
